import { useRef } from 'react';
import VideoCard from '@/components/base/VideoCard';
import { videos } from '@/mocks/videos';

export default function HotRecommendations() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const hotVideos = videos.filter((v) => v.rating >= 9.2);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="section-padding bg-background-100">
      <div className="container-custom">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">
              高分热门视频，大家都在看
            </p>
          </div>
          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:bg-background-200 hover:border-foreground-400 transition-all"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:bg-background-200 hover:border-foreground-400 transition-all"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto scrollbar-hide pb-4 -mx-4 px-4 snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {hotVideos.map((video) => (
            <div key={video.id} className="flex-shrink-0 w-[280px] md:w-[320px] snap-start">
              <VideoCard video={video} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}